var intersection = require('../helpers/array-intersection');

module.exports = function() {

  var opts = this.opts;

  return opts.dateColumns.length &&
         opts.filterByColumn &&
         ((typeof opts.filterable=='boolean' && opts.filterable) || intersection(opts.filterable, opts.dateColumns).length)
}



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/methods/has-date-filters.js